import React from "react"
import AIModalJson from "../../Configs/JSON/MobileModal.json"
import GenericModal from "../Common/GenericModal"
import CircleIcon from "../Common/CircleIcon"
import { observer } from "mobx-react"
import AppStore from "../../Configs/Store/index"
import FormStore from "../../Configs/Store/forms"
import "../../styles/Benefits/ResultBlock.less"

const MobileModal = observer(() => {
  const handleclose = () => {
    FormStore.setMobileModal(false)
  }
  return (
    <div>
      <GenericModal
        visibleState={FormStore.calc_mobModal}
        updateVisibility={() => FormStore.setMobileModal(false)}
        closeIcon={<CircleIcon iconUrl={"common/Iconionic-md-close-circle-outline"} />}
        rootClassAntCustom={"AnnualIncomeModal"}
        showButton={true}
        buttonText={AIModalJson["buttonText"]}
        buttonWrapper={"calculateFormDiv"}
        buttononClick={() => FormStore.setMobileModal(false)}
        component={
          <div className="contentWrap">
            {/* <CircleIcon iconStyle="titleICon" iconUrl={AIModalJson["mainIcon"]} /> */}
            {/* <div className="SectionTitle">{AIModalJson["modalTitle"]}</div> */}
            <button className="CloseButton" data-dismiss="modal" aria-label="Close" onClick={handleclose}>
              {/* <span aria-hidden="true">&times;</span> */}
            </button>
            <div className="Content" dangerouslySetInnerHTML={{ __html: AIModalJson["modalContent"] }}>
              {}
            </div>
          </div>
        }
      />
    </div>
  )
})

export default MobileModal
